import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { v4 as uuid } from 'uuid';

import { useForm } from 'react-hook-form';

import Box from '@mui/material/Box';

import { datasetsActions, datasetsTypes } from 'app-components/flux/datasets';
import { profileSelectors } from 'app-components/flux/profile';

import StdDialog from 'components/Dialogs/StdDialog';
import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';
import StdDialogForm from 'components/Dialogs/StdDialogForm';

import QIllustration from 'components/QIllustration';
import TextField from 'components/ReactFormHook/TextField';

type Props = {
  dataset?: any;
  onClose: any;
};

const UpsertDatasetDialog = ({ dataset, onClose }: Props) => {
  const dispatch = useDispatch();

  const profile = useSelector(profileSelectors.getProfile);
  const zipcode = dataset ? dataset.zipcode : profile?.primaryAddress?.zipCode;

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
  } = useForm({ defaultValues: { name: dataset ? dataset.name : '', zipcode: zipcode || '' } });

  // @ts-expect-error FIXME TS7006
  const onSubmit = (data) => {
    const datasetToUpsert = datasetsTypes.mkDataset({
      ...(dataset && { id: dataset.id }),
      clientId: uuid(),
      name: data.name,
      // purpose: data.purpose,
      zipcode: data.zipcode,
    });
    dispatch(
      !dataset ? datasetsActions.createDataset(datasetToUpsert) : datasetsActions.updateDataset(datasetToUpsert),
    );
    onClose();
  };

  const renderAddDatasetForm = () => (
    <StdDialogForm onSubmit={handleSubmit(onSubmit)}>
      <StdDialogContent
        id='upsert_dataset_dialog_content'
        sx={{ display: 'flex', alignItems: 'start', flexDirection: 'row' }}
      >
        <Box p={3}>
          <QIllustration name='sharingUser' size='lg' />
        </Box>
        <Box display='flex' flex='1' flexDirection='column' ml={3} mr={13}>
          <TextField
            name='name'
            id='create-space-name'
            control={control}
            label='Name'
            rules={{ required: true }}
            sx={{ mt: 2, mb: 2 }}
            variant='filled'
          />
          <TextField
            name='zipcode'
            id='create-space-zipcode'
            control={control}
            label='ZIP Code'
            rules={{ required: true }}
            sx={{ mt: 2, width: '25ch' }}
            variant='filled'
          />
        </Box>
      </StdDialogContent>
      <StdDialogActions
        primary={{
          children: !dataset ? 'Create' : 'Update',
          disabled: isSubmitting,
        }}
        secondary={{
          children: 'Cancel',
          onClick: onClose,
          variant: 'outlined',
        }}
      />
    </StdDialogForm>
  );

  return (
    <StdDialog
      disableBackdropClick
      onClose={onClose}
      open
      showCloseButton
      size='md'
      title={!dataset ? 'Create space' : 'Edit space'}
    >
      {renderAddDatasetForm()}
    </StdDialog>
  );
};

export default UpsertDatasetDialog;
